import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./hint.css";


export const HoverHint = ({caption}) => {
    return (
        <div className='hint-container'>
            <div className='hint-point'>
                <div className='hint-box'>
                    <div className='hint-text'>{caption}</div>
                    <div className='hint-pointer'/>
                </div>
                <FontAwesomeIcon icon={faQuestionCircle} className='q-mark' />
            </div>
        </div>
    );
}